import { MockQuoteEngine, type QuoteEngine } from "@lawnops/shared";

/**
 * Choose the right quote engine for the current environment.
 *
 * Stage 2 today: always the MockQuoteEngine.
 * Stage 2 once API keys land: a thin client wrapper that calls the
 * `quote-from-address` Supabase Edge Function, which in turn talks to
 * Google Maps Static API + Claude vision. Swap-in is one line below.
 */
export function getQuoteEngine(): QuoteEngine {
  return new MockQuoteEngine();
}
